import { Component, OnInit } from '@angular/core';
import { Subscribe } from '../model/subscribe.model';
import { SubscribeService } from '../services/subscribe.service';
var RazorPay: any;
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  email!:string;
  subscribe: Subscribe = new Subscribe();
  submitted = false;

  constructor(private subscribeService: SubscribeService) { }

  ngOnInit(): void {
  }
  onSubscribe(){

      if(!this.subscribe.email){
      window.alert('Fill the required field..!');
    }else{
      this.submitted = true;
     if(this.submitted){
      this.subscribeService.create(this.subscribe).then(() => {
        window.alert('Subscribed successfully!');
    });

    }
  }
}
}
